import { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import API from "../../../../utils/API";

class DisconnectPrinterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activeSimpleZebraDevices: [],
            options: [],
            selectedSimpleZebraDevice: null,
            selectedSimpleZebraDeviceFriendlyName: props.printer ? props.printer.friendlyName : '',
            requiredFieldsFilled: false,
        }
    }


    disconnectPrinter = async () => {
        const { toggle, checkInAppConfiguration, printer } = this.props;
        const payload = {
            organizationId: '',
            eventId: '',
            simpleZebraId: printer._id,
            friendlyName: this.state.selectedSimpleZebraDeviceFriendlyName,
        };

        await API().patch(`/patchActiveZebraPrinter`, payload).then((res) => {
            if (res.data) {
                let updatedActiveSimpleZebraDevices = checkInAppConfiguration.zebraPrinters || [];
                let updatedZebra = res.data.zebraPrinter;
                const existingIndex = updatedActiveSimpleZebraDevices.findIndex(device => device._id === updatedZebra._id);
                if (existingIndex !== -1) {
                    updatedActiveSimpleZebraDevices.splice(existingIndex, 1);
                }
                this.props.updatedActiveSimpleZebraDevices(updatedActiveSimpleZebraDevices);
                toggle();
            }
        });
    }

    render() {
        const { isOpen, toggle, printer } = this.props;
        const { submitting } = this.state;


        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Disconnect Printer"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <p>Are you sure you want to disconnect the printer <strong>{printer ? printer.friendlyName : ''}</strong>?</p>
                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Disconnect ' : 'Disconnecting...'}
                actionButton={() => this.disconnectPrinter()}
                actionButtonDisabled={submitting}
            ></FieldModal>
        </div>
    }
}

export default DisconnectPrinterModal;